
import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { switchMap } from 'rxjs/operators';
import { SeguimientoService } from '../../../services/formulacion/seguimiento.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import { CategoriaProgService } from 'src/app/services/service.index';

declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-consolidado',
  templateUrl: './consolidado.component.html',
  styles: []
})
export class ConsolidadoComponent implements OnInit {
  baseUrl = environment.apiEndpoint;
  file: File = null;
  maxFileSize = 2097152;
  typeFiles = ['text/csv', 'text/xlsx', 'text/xls', '.xls', '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
  hasError: any;
  model: any;
  fecha_inicio = new Date();
  fecha_fin = new Date();
  ver_botonReporte: boolean = false;
  dataResource: any[];
  dataResourceCP: any[];
  popupVisible: boolean = false;
  mes_ini: number = 0;
  mes_fin: number = 0;  
  i: string;
  f: string;
  gestion: number =0;
  gestion_id: number = 0;
  user_id: number =0;
  constructor(private _ss: SeguimientoService) {
    let u = JSON.parse(localStorage.getItem('u'));
    this.user_id = u.id;
    this.gestion_id = u.gestion_id;
    this.resetErrors();    
    this.getMonth();
  }

  ngOnInit() {
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

  convertDate(date: Date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    let nd = dd.toString();
    let nm = mm.toString();
    var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
    return nd + '/' + nm + '/' + yyyy;
  }

  getMonth() {
    this.mes_ini = this.fecha_inicio.getMonth() + 1;
    this.mes_fin = this.fecha_fin.getMonth() + 1;    
  }


  convertDate2(date: Date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    let nd = dd.toString();
    let nm = mm.toString();
    var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
    return nm + '/' + nd + '/' + yyyy;
  }

  onChangeFI(e: any) {

    this.i = this.convertDate2(e.value);
    this.mes_ini = new Date(this.i).getMonth() + 1;    
  }

  onChangeFF(e: any) {

    this.f = this.convertDate2(e.value);
    this.mes_fin = new Date(this.f).getMonth() + 1;  
    this.gestion = new Date(this.f).getFullYear();
    this.listaSegAuxSigep();
  }

  registrarXls() {

    this.model.fecha_inicio = this.convertDate(this.fecha_inicio);
    this.model.fecha_fin = this.convertDate(this.fecha_fin);

    if (this.validSave()) {

      this._ss.postImportXls(this.model, this.file).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.ver_botonReporte = true;
            this.listaSegAuxSigep();
            toastr.success('Datos guardados correctamente.');
          }
          if (result.status == 201) {
            toastr.warning(result.data);
          }
        });
    }
  }

  handleFileInput(files: FileList) {
    this.file = files.item(0);
    if (this.file != null) {
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG y PNG.');
      }
    }
  }

  resetErrors() {
    this.model = { id: 0, fecha_inicio: '', fecha_fin: '', file: null };
    this.hasError = { fechaC31: false, file: false };
  }

  validSave() {
    let res = true;
    if (!UtilHelper.validator(this.model.fecha_inicio, 'ddmmyyyy')) {
      this.hasError.fecha_inicio = true; res = false;
    }
    if (!UtilHelper.validator(this.model.fecha_fin, 'ddmmyyyy')) {
      this.hasError.fecha_fin = true; res = false;
    }
    if (this.file != null) {
      if (this.file.size > this.maxFileSize) {
        toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
        this.hasError.file = true; res = false;
      }
      if (this.typeFiles.indexOf(this.file.type) == -1) {
        toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG y PNG.');
        this.hasError.file = true; res = false;
      }
    }
    else {
      this.hasError.file = true; res = false;
    }
    return res;
  }

  listaSegAuxSigep() {
    this._ss.getLstSegAuxSigep(this.mes_fin, this.gestion).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResource = result.data;
        } else {
          this.dataResource = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  showModalEdit(data: any) {
    this.getTecho();
    this.model.id = data.id;
    this.model.categoria_programatica_id = data.descripcion_techo;
    this.model.categoria_programatica = data.categoria_programatica;
    this.model.categoria_programatica_descripcion = data.categoria_programatica_descripcion;
    this.model.techo_id = data.techo_id;
    this.popupVisible = true;

  }

  getTecho() {
    this._ss.getTechosActivos().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceCP = result.data;          
        } else {
          this.dataResourceCP = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getDescripcionCP(e: any) {
    if (e.value != undefined && e.value != null)
      this.model.techo_id = e.value;
    console.log('techo:', this.model.techo_id);
  }

  saveTechoAuxSigep() {    
    if (this.model.techo_id != 0) {
      this._ss.putTechoAuxSigep(this.model).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.listaSegAuxSigep();
            this.popupVisible = false;            
            toastr.success('Datos guardados exitosamente.');
          }
        },
        error => { console.log('Error', error); });
    }
  }

  getReporteSeguimiento(gestion_id: number) {
    this.mes_ini = this.model.fecha_inicio.getMonth();
    this.mes_fin = this.model.fecha_fin.getMonth();
 
    window.location.href = "http://localhost/api/xls/seguimientoPOA/?id=5&estado=Completado";

  }

}
